
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, BarChart3, Calendar } from "lucide-react";
import { format } from "date-fns";
import { OrganizationWithRelations } from "@/types/organization.types";

interface ContractInfoCardProps {
  organization: OrganizationWithRelations;
}

export function ContractInfoCard({ organization }: ContractInfoCardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Contract Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {organization.contract_value && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground flex items-center">
              <Briefcase className="h-4 w-4 mr-1" /> Contract Value:
            </span>
            <span className="text-sm font-medium">
              ${organization.contract_value.toLocaleString()}
            </span>
          </div>
        )}
        
        {organization.monthly_retainer && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground flex items-center">
              <BarChart3 className="h-4 w-4 mr-1" /> Monthly Retainer:
            </span>
            <span className="text-sm font-medium">
              ${organization.monthly_retainer.toLocaleString()}
            </span>
          </div>
        )}
        
        {organization.retainer_type && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">Retainer Type:</span>
            <span className="text-sm font-medium">{organization.retainer_type}</span>
          </div>
        )}
        
        {organization.start_date && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground flex items-center">
              <Calendar className="h-4 w-4 mr-1" /> Start Date:
            </span>
            <span className="text-sm font-medium">
              {format(new Date(organization.start_date), 'MMM d, yyyy')}
            </span>
          </div>
        )}
        
        {organization.contract_renewal_date && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground flex items-center">
              <Calendar className="h-4 w-4 mr-1" /> Renewal Date:
            </span>
            <span className="text-sm font-medium">
              {format(new Date(organization.contract_renewal_date), 'MMM d, yyyy')}
            </span>
          </div>
        )}
        
        {organization.reporting_cycle && (
          <div className="flex justify-between">
            <span className="text-sm font-medium text-muted-foreground">Reporting Cycle:</span>
            <span className="text-sm font-medium">{organization.reporting_cycle}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
